import { getI18n } from 'react-i18next';

export const VALIDATION_INVALID_USER_ID = 'validation.invalidUserId';
export const VALIDATION_OLD_PASSWORD_NOT_MATCH = 'validation.oldPasswordNotMatch';
export const VALIDATION_NEW_PASSWORDS_NOT_MATCH = 'validation.newPasswordsNotMatch';
export const VALIDATION_NEW_PASSWORD_INVALID_BASED_ON_USER_FIELDS = 'validation.newPasswordInvalid.basedOnUserFields';
export const VALIDATION_NEW_PASSWORD_INVALID_CHANGED_TOO_SOON = 'validation.newPasswordInvalid.changedTooSoonAfterPreviousChange';
export const VALIDATION_NEW_PASSWORD_INVALID_PASS_IN_DICTIONARY = 'validation.newPasswordInvalid.passwordInDictionary';
export const VALIDATION_NEW_PASSWORD_INVALID_PALINDROME = 'validation.newPasswordInvalid.palindrome';
export const VALIDATION_NEW_PASSWORD_INVALID_RESTRICTED_WORD = 'validation.newPasswordInvalid.restrictedWord';
export const VALIDATION_NEW_PASSWORD_INVALID_MONOTONIC_SEQUENCE = 'validation.newPasswordInvalid.monotonicSequence';
export const VALIDATION_NEW_PASSWORD_INVALID_REPEATED_IDENTICAL_SEQUENCES = 'validation.newPasswordInvalid.repeatedIdenticalSequences';
export const VALIDATION_NEW_PASSWORD_INVALID_REPEATED_CLASS_CHARACTERS = 'validation.newPasswordInvalid.repeatedClassCharacters';
export const VALIDATION_NEW_PASSWORD_INVALID_PASS_IN_HISTORY = 'validation.newPasswordInvalid.passwordInHistory';
export const VALIDATION_NEW_PASSWORD_INVALID_INVALID_LENGTH = 'validation.newPasswordInvalid.invalidLength';
export const VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_DIGITS = 'validation.newPasswordInvalid.tooFewDigits';
export const VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_ALPHA_CHARS = 'validation.newPasswordInvalid.tooFewAlphabeticChars';
export const VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_UC_CHARS = 'validation.newPasswordInvalid.tooFewUppercaseChars';
export const VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_LC_CHARS = 'validation.newPasswordInvalid.tooFewLowercaseChars';
export const VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_SPECIAL_CHARS = 'validation.newPasswordInvalid.tooFewSpecialChars';
export const VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_8BIT_CHARS = 'validation.newPasswordInvalid.tooFew8BitChars';
export const VALIDATION_NEW_PASSWORD_INVALID_TOO_MANY_CHAR_REPEATS = 'validation.newPasswordInvalid.tooManyCharRepeats';
export const VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_CHAR_CATEGORIES = 'validation.newPasswordInvalid.tooFewCharCategories';
export const VALIDATION_NEW_PASSWORD_INVALID_UNKNOWN_REASON = 'validation.newPasswordInvalid.unknownReason';
export const VALIDATION_NEW_PASSWORD_UNEXPECTED = 'validation.newPassword.unexpected';
export const VALIDATION_NEW_PASSWORD_TOKEN_INVALID = 'validation.newPassword.tokenInvalid';

export const createPasswordErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_INVALID_USER_ID:
            result = i18n.t('passwords.error.invalid-user-id');
            break;
        case VALIDATION_OLD_PASSWORD_NOT_MATCH:
            result = i18n.t('passwords.error.old-password-not-match');
            break;
        case VALIDATION_NEW_PASSWORDS_NOT_MATCH:
            result = i18n.t('passwords.error.new-password-not-match');
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_BASED_ON_USER_FIELDS:
            result = i18n.t('passwords.error.new-password-invalid.based-on-user-fields', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_CHANGED_TOO_SOON:
            result = i18n.t('passwords.error.new-password-invalid.changed-too-soon', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_PASS_IN_DICTIONARY:
            result = i18n.t('passwords.error.new-password-invalid.pass-in-dictionary', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_PALINDROME:
            result = i18n.t('passwords.error.new-password-invalid.palindrome', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_RESTRICTED_WORD:
            result = i18n.t('passwords.error.new-password-invalid.restricted-word', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_MONOTONIC_SEQUENCE:
            result = i18n.t('passwords.error.new-password-invalid.monotonic-sequence', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_REPEATED_IDENTICAL_SEQUENCES:
            result = i18n.t('passwords.error.new-password-invalid.repeated-identical-sequences', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_REPEATED_CLASS_CHARACTERS:
            result = i18n.t('passwords.error.new-password-invalid.repeated-class-characters', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_PASS_IN_HISTORY:
            result = i18n.t('passwords.error.new-password-invalid.pass-in-history', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_INVALID_LENGTH:
            result = i18n.t('passwords.error.new-password-invalid.invalid-length', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_DIGITS:
            result = i18n.t('passwords.error.new-password-invalid.too-few-digits', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_ALPHA_CHARS:
            result = i18n.t('passwords.error.new-password-invalid.too-few-alpha-chars', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_UC_CHARS:
            result = i18n.t('passwords.error.new-password-invalid.too-few-uc-chars', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_LC_CHARS:
            result = i18n.t('passwords.error.new-password-invalid.too-few-lc-chars', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_SPECIAL_CHARS:
            result = i18n.t('passwords.error.new-password-invalid.too-few-special-chars', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_8BIT_CHARS:
            result = i18n.t('passwords.error.new-password-invalid.too-few-8bit-chars', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_TOO_MANY_CHAR_REPEATS:
            result = i18n.t('passwords.error.new-password-invalid.too-many-char-repeats', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_TOO_FEW_CHAR_CATEGORIES:
            result = i18n.t('passwords.error.new-password-invalid.too-few-char-categories', params);
            break;
        case VALIDATION_NEW_PASSWORD_INVALID_UNKNOWN_REASON:
            result = i18n.t('passwords.error.new-password-invalid.unknown-reason', params);
            break;
        case VALIDATION_NEW_PASSWORD_UNEXPECTED:
            result = i18n.t('passwords.error.unexpected', params);
            break;
        case VALIDATION_NEW_PASSWORD_TOKEN_INVALID:
            result = i18n.t('passwords.error.token-invalid', params);
            break;
        default:
            result = undefined;
    }
    return result;
};
